import flattenDeep from 'lodash/flattenDeep';
import React, { useMemo } from 'react';
import { getSelectionGroupItemByIndex } from '../utils';
import { selectionConfig } from '@/components/widget/visualizations/List';
import useSelections from '@/components/widget/misc/useSelections';
import useSubscribeWidgetResults from '@/components/widget/visualizations/hooks/useSubscribeWidgetResults';
import { TemplateRevealPill } from '@/components/Editor/Form/fields/Template';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const EditorFormListFields = ( // eslint-disable-next-line no-empty-pattern
_ref) => {
  var _config$globalSeriesO;

  let {
    sectionId,
    reportingWidgetId,
    config,
    onChange
  } = _ref;
  const templateFieldId = `list-template-${sectionId}`;
  const {
    selections = '',
    selectionsLabeled = false
  } = config; // Get current selection results

  const results = useSubscribeWidgetResults(reportingWidgetId); // Get relevant results for each selection group

  const {
    selectionResults
  } = useSelections({
    results,
    selections,
    selectionConfig,
    selectionsLabeled
  });
  const exampleValue = useMemo(() => {
    const exampleSelection = getSelectionGroupItemByIndex(flattenDeep(selectionResults), 0);
    return typeof exampleSelection.value !== 'undefined' ? exampleSelection.value : 10;
  }, [selectionResults]); // Placeholder

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(TemplateRevealPill, {
      id: templateFieldId,
      label: "General Format",
      caption: "Default formatting. Can be overwritten by other formatting settings.",
      exampleValue: exampleValue,
      template: (_config$globalSeriesO = config.globalSeriesOptions) === null || _config$globalSeriesO === void 0 ? void 0 : _config$globalSeriesO.template,
      onChange: value => onChange('globalSeriesOptions', {
        template: value
      })
    })
  });
};

export default EditorFormListFields;